module.exports = __webpack_public_path__ + "static/media/2023-02-09-slider-1.e1c6e6e6.jpg";